import debounce from 'lodash/debounce';
import { fillParentContainer } from 'fancy-textfill';

$(document).ready(handleDynamicSizes);

$(window).on('resize', debounce(handleDynamicSizes, 100));

function handleDynamicSizes() {
  titleIconSizes();
  onePlusRangeSizes();
}

function titleIconSizes() {
  const iconText = document.querySelectorAll('.js-icon-title');

  iconText.forEach(element => {
    fillParentContainer(element, {
      maxFontSize: 32,
      minFontSize: 11,
      maxHeight: element.parentElement.offsetHeight,
      maxLineHeight: 70,
    });
  });
}

function onePlusRangeSizes() {
  const line1 = document.querySelector('.js-oneplus-range-line-1');
  const line3 = document.querySelector('.js-oneplus-range-line-3');
  const line4 = document.querySelector('.js-oneplus-range-line-4');

  if (line1) {
    fillParentContainer(line1, {
      maxFontSize: 105,
      minFontSize: 11,
      maxHeight: line1.parentElement.offsetHeight,
      maxLineHeight: 80,
    });
  }

  if (line3) {
    fillParentContainer(line3, {
      maxFontSize: 130,
      minFontSize: 11,
      maxHeight: line3.parentElement.offsetHeight,
      maxLineHeight: 95,
    });
  }

  if (line4) {
    fillParentContainer(line4, {
      maxFontSize: 85,
      minFontSize: 11,
      maxHeight: line4.parentElement.offsetHeight,
      maxLineHeight: 65,
    });
  }
}
